import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, fieldInputPropType, propTypes } from 'redux-form';
import { Select } from 'antd';
import { validateMoney } from 'utils/validation';
import { Input, Checkbox, VirtualizedSelect } from 'components/UIForm';
import { Button } from 'components/UI';
import { saveParticipant } from 'redux_store/modules/tenderCard';

import styles from './styles.scss';

const statuses = [
  { id: true, name: 'Допущен' },
  { id: false, name: 'Не допущен' },
];

const selectAfter = ({ input: { value, onChange, name }, options }) => (
  <Select name={name} value={value} onChange={onChange} style={{ width: 80 }}>
    {options.map(x => (
      <Select.Option key={x.id} value={x.id} className={styles.currencyOption}>
        {x.name}
      </Select.Option>
    ))}
  </Select>
);

selectAfter.propTypes = {
  ...fieldInputPropType,
  // eslint-disable-next-line react/forbid-prop-types
  options: PropTypes.arrayOf(PropTypes.object),
};

selectAfter.defaultProps = {
  options: [],
};

@reduxForm({
  // form: 'editZone',
  onSubmit: saveParticipant,
  validate: values => {
    const errors = {};
    if (values.price) {
      const er = validateMoney(values.price);
      if (er) {
        errors.price = er;
      }
    }

    return errors;
  },
})
export default class TenderParticipantsEditRow extends React.PureComponent {
  static propTypes = {
    ...propTypes,
  };

  render() {
    const { submitting, handleSubmit, onRequestClose, currency } = this.props;
    return (
      <form className={styles.editRow} onSubmit={handleSubmit}>
        <div className={styles.check}>
          <Field component={Checkbox} name="winner">
            Победитель
          </Field>
        </div>
        <div className={styles.check}>
          <Field component={Checkbox} name="refuseContract">
            Отказ от контракта
          </Field>
        </div>
        <div className={styles.price}>
          <Field
            component={Input}
            className={styles.input}
            placeholder="Предложенная цена"
            addonAfter={<Field name="currencyId" component={selectAfter} options={currency} />}
            name="price"
            autoFocus
          />
        </div>
        <div className={styles.status}>
          <Field
            name="allowed"
            component={VirtualizedSelect}
            placeholder="Статус"
            options={statuses}
            labelKey="name"
            valueKey="id"
            style={{ minWidth: 181, height: 32 }}
          />
        </div>
        <div className={styles.buttons}>
          <Button color="blue" htmlType="submit" disabled={submitting}>
            Сохранить
          </Button>
          <Button color="white" onClick={onRequestClose} disabled={submitting}>
            Отменить
          </Button>
        </div>
      </form>
    );
  }
}
